/*
 * @Description:常用js封装
 * @Version: 1.0.0
 * @Date: 2021-01-05 09:30:11
 */
import SparkMD5 from 'spark-md5'

const common = {
  /**
   * @description: 文件流下载封装
   * @param { res } 二进制文件流，必传
   * @param { type } 下载文件类型，必传
   * @param { fileExtension } 文件后缀名，必传
   * @param { name} 文件名称，非必传
   * @return {*}
   */
  exportFile(res, type, fileExtension, name) {
    const content = res
    const blob = new Blob([content], { type: type })
    var timestamp = Date.parse(new Date()) // 默认文件名为时间戳
    const fileName = name ? name + fileExtension : timestamp + fileExtension
    if ('download' in document.createElement('a')) {
      // 非IE下载
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  },

  /**
   * Parse the time to string
   * @param {(Object|string|number)} time
   * @param {string} cFormat
   * @returns {string | null}
   */
  parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          time = parseInt(time)
        } else {
          // support safari
          // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }

      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
    return time_str
  },

  /**
   * @description: 素材封面图处理
   * @param {*} data
   * @return {*}
   */
  // getMaterialCoverUrl(data) {
  //   switch (data.type) {
  //     case 1:
  //       return data.thumbnailUrl
  //     case 2:
  //       return require('@/assets/material-type/audio.png')
  //     case 3:
  //       return data.thumbnailUrl
  //     case 4:
  //       return require(`@/assets/material-type/${data.fileFormat}.png`)
  //     case 5:
  //       return require('@/assets/material-type/other.png')
  //     case 6:
  //       if (data.thumbnailUrl) {
  //         return data.thumbnailUrl
  //       } else {
  //         switch (data.storyType) {
  //           case 'VIDEO':
  //             return require('@/assets/material-type/video-story.png')
  //           case 'GALLERY':
  //             return require('@/assets/material-type/images-story.png')
  //           case 'HREF':
  //             return require('@/assets/material-type/link-story.png')
  //           default:
  //             return require('@/assets/material-type/media-story.png')
  //         }
  //       }
  //     case 100:
  //       return require('@/assets/material-type/folder.png')
  //   }
  // },

  generateRandomString() {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const maxLength = charset.length;
    const minLength = 4;
    const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

    const randomBytes = new Uint8Array(length);
    window.crypto.getRandomValues(randomBytes);

    let result = '';
    for (let i = 0; i < length; i++) {
      result += charset[randomBytes[i] % charset.length];
    }
    return result;
  },
  /**
   * @description: 生成唯一ID
   * @param {*}
   * @return {*}
   */
  guid() {
    return Number(
      Math.random()
        .toString()
        .substr(3, 3) + Date.now()
    ).toString(36)
  },
  /**
   * @description: a标签下载文件
   * @param {*} url
   * @return {*}
   */
  downloadDom(url) {
    const downloadDom = document.createElement('a')
    downloadDom.setAttribute('href', url)
    document.body.appendChild(downloadDom)
    downloadDom.click()
    document.body.removeChild(downloadDom)
  },
  /**
   * @description: 正则获取字符串中（）里内容
   * @param {*} str
   * @return {Arrary}
   */
  getExecStrs(str) {
    var reg = /\((.+?)\)/g
    var list = []
    var result = null
    do {
      result = reg.exec(str)
      result && list.push(result[1])
    } while (result)
    return list
  },
  /**
   * @description: 换肤加class函数
   * @param {*}
   * @return {*}
   */
  toggleClass(element, className) {
    if (!element || !className) return
    element.className = className
  },
  /**
   * [通过参数名获取url中的参数值]
   * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=张三
   */
  // 获取浏览器url参数
  parseQueryString: function (url) {
    var result = {}
    if (url.indexOf('?') > -1) {
      var str = url.split('?')[1]
      var temp = str.split('&')
      for (var i = 0; i < temp.length; i++) {
        var temp2 = temp[i].split('=')
        result[temp2[0]] = temp2[1]
      }
    }
    return result
  },
  /**
   * @description: rgb和十六进制的转换
   * @param {*}
   * @return {*}
   */
  colorRgb(color) {
    // 16进制颜色值的正则
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
    // 把颜色值变成小写
    if (reg.test(color.toLowerCase())) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (color.length === 4) {
        var colorNew = '#'
        for (var i = 1; i < 4; i += 1) {
          colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
        }
        color = colorNew
      }
      // 处理六位的颜色值，转为RGB
      var colorChange = []
      for (var j = 1; j < 7; j += 2) {
        colorChange.push(parseInt('0x' + color.slice(j, j + 2)))
      }
      return colorChange
      // return 'RGB(' + colorChange.join(',') + ')'
    } else {
      return color
    }
  },
  /**
   * @description: 对象或数组深拷贝
   */
  deepCopy(source) {
    var sourceCopy = source instanceof Array ? [] : {}
    for (var item in source) {
      sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item]
    }
    return sourceCopy
  },

  // 转换回车
  br2nl(txt) {
    const re = /(<br\/>|<br>|<BR>|<BR\/>)/g
    const s = txt.replace(re, "\n")
    return s
  },

  // js保留两位小数（不四舍五入）
  formatDecimal(num, decimal) {
    num = num.toString()
    let index = num.indexOf('.')
    num = (index !== -1) ? num.substring(0, decimal + index + 1) : num.substring(0)
    return Number(num)
  },

  // md5加密
  computeMD5(file) {
    return new Promise((resolve, reject) => {
      const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      const fileReader = new FileReader()
      const chunkSize = 2097152
      const chunks = 1
      let currentChunk = 0
      // 注意点，网上都是 这一步都是有问题的， SparkMD5.ArrayBuffer()
      const spark = new SparkMD5.ArrayBuffer()
      fileReader.onload = function (e) {
        spark.append(e.target.result)
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          const sparkEnd = spark.end()
          resolve(sparkEnd) // 计算后的结果
        }
      }
      fileReader.onerror = function (e) { reject(e) }
      function loadNext() {
        const start = currentChunk * chunkSize
        const end = start + chunkSize >= file.size ? file.size : start + chunkSize
        // 注意这里的 fileRaw
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
      }
      loadNext()
    })
  },
  // 防抖
  debounce(fn, delay = 300) {   //默认300毫秒
    let timer;
    return function () {
      let args = arguments;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn.apply(this, args);   // this 指向vue
      }, delay);
    };
  },
  // 时间戳转时分秒
  formatTime(timestamp) {
    const totalSeconds = Math.floor(timestamp); // 如果时间戳是毫秒级别的，需要除以 1000
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}

export default common
